









































import { Component, Mixins } from 'vue-mixin-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import { Prop } from 'vue-property-decorator';

@Component
export default class DefaultLayout extends Mixins<SlotMixin>(SlotMixin) {
  @Prop() private without_footer!: boolean;
}
